export type ExtendQuoteSlice = {
    catalog: {
        error: string;
        loading: boolean;
        success: boolean;
    };
    invoice: {
        error: string;
        loading: boolean;
        success: boolean;
    };
};

export const defaultExtendQuoteSlice: ExtendQuoteSlice = {
    catalog: {
        error: '',
        loading: false,
        success: false,
    },
    invoice: {
        error: '',
        loading: false,
        success: false,
    },
};

export type PostExtendQuoteResponse = {
    error: boolean;
    payload: string;
};

export type BasePostExtendQuoteParams = {
    authToken: string;
    deployment: string;
};

export type ExtendQuoteByInvoiceIdParams = {
    invoiceId: number;
};

export type ExtendQuoteByCatalogIdParams = {
    catalogId: number;
};
